import {SupportWidgetProvider} from '@logistics-frontend/blocks'
import React from 'react'
import {useParams} from 'react-router-dom'

import {config, isDevEnv} from 'src/config'

import {CompleteScreen} from './components/screens'
import {SharedRoute} from './components/shared-route'
import {SharedRoutePageContext} from './context'
import {usePageContextParams} from './hooks'
import {RouterParams} from './types'

const Page: React.FC = () => {
  const {sharingKey = ''} = useParams<RouterParams>()
  const contextParams = usePageContextParams()

  return (
    <SharedRoutePageContext.Provider value={contextParams}>
      <SupportWidgetProvider
        botID={config.supportBotID}
        country={config.country}
        debug={isDevEnv ? 'transport:xiva:push' : undefined}
        lang={config.lang}
        serviceID={config.messengerServiceID}
        simple={config.brand !== 'yandex'}
      >
        {sharingKey ? <SharedRoute sharingKey={sharingKey}/> : <CompleteScreen/>}
      </SupportWidgetProvider>
    </SharedRoutePageContext.Provider>
  )
}

export default Page
